import { z } from "zod";

export const paymentMethodSchema = z.object({
  card_token: z.string().min(1, "Card token is required"),
  set_as_default: z.boolean().default(true),
  type: z.string().min(1, "Payment method type is required"),
});

export type PaymentMethodFormValues = z.infer<typeof paymentMethodSchema>;
